import createIcon from '../../createIcon';

/**
 * @component @name MonitorWeight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk0xMiAxMkMxMC4zNCAxMiA5IDEwLjY2IDkgOUM5IDcuMzQgMTAuMzQgNiAxMiA2QzEzLjY2IDYgMTUgNy4zNCAxNSA5QzE1IDEwLjY2IDEzLjY2IDEyIDEyIDEyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExIDguNUgxMFY5LjVIMTFWOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjUgOC41SDExLjVWOS41SDEyLjVWOC41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDguNUgxM1Y5LjVIMTRWOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MonitorWeight = createIcon('MonitorWeight', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12Z',
      key: '1fzvhi',
    },
  ],
  ['path', { d: 'M11 8.5H10V9.5H11V8.5Z', key: 'x66fxs' }],
  ['path', { d: 'M12.5 8.5H11.5V9.5H12.5V8.5Z', key: '1dybc1' }],
  ['path', { d: 'M14 8.5H13V9.5H14V8.5Z', key: 'n6049f' }],
]);

export default MonitorWeight;
